import { useTranslation } from "react-i18next";

import { CablePDMeasurement } from "../../shared/interfaces/Result";
import { MeasurementType } from "../../shared/enums/Result";

import { Card } from "../../shared/Card";
import { FormRow } from "../../shared/FormLayout/FormRow";
import { useInternationalFormatters } from "../../shared/helpers/useInternationalFormatters";

interface CablePDMeasurementCardProps {
  measurement: CablePDMeasurement;
}

export function CablePDMeasurementCard(props: CablePDMeasurementCardProps) {
  const { t } = useTranslation();
  const { formatNumber } = useInternationalFormatters();

  return (
    <Card
      title={t("results.measurementType", {
        measurementType: `$t(MeasurementTypes.${MeasurementType.CablePD} )`,
      })}
      className="mb-3"
    >
      <FormRow label={t("measurements.MeasurePC")} value={props.measurement.MeasurePC} />
      <FormRow label={t("measurements.MeasurePPC")} value={formatNumber(props.measurement.MeasurePPC, 2)} />
      <FormRow
        label={t("measurements.FilterName")}
        value={props.measurement.FilterName && t(`CablePDFilterName.${props.measurement.FilterName}`)}
      />
      <FormRow label={t("measurements.CTModel")} value={props.measurement.CTModel} />
      <FormRow
        label={t("measurements.PhaseReferenceLock")}
        value={props.measurement.PhaseReferenceLock ? t("common.true") : t("common.false")}
      />
      <FormRow
        label={t("measurements.PhaseReferenceType")}
        value={props.measurement.PhaseReferenceType && t(`PhaseReferenceType.${props.measurement.PhaseReferenceType}`)}
      />
    </Card>
  );
}
